import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { ComponentProps, memo } from 'react';

import LineChartImpl from './LineChartImpl';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const areEqual = (
  prevProps: ComponentProps<typeof LineChartImpl>,
  nextProps: ComponentProps<typeof LineChartImpl>
) => JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data);

// eslint-disable-next-line react-refresh/only-export-components
export default memo(LineChartImpl, areEqual);
